import { BarChart, Bar, XAxis, YAxis, Tooltip, ReferenceLine, ResponsiveContainer, Cell } from "recharts";

export function CycleHistoryBarStrip({ history = [], stats = {} }) {
  if (!history || history.length === 0) {
    return (
      <div className="flex h-40 items-center justify-center rounded-xl border border-dashed border-slate-200 bg-slate-50/50 text-sm text-slate-500" data-testid="cycle-history-bar-strip-empty">
        First cycle still in progress — history will appear once it closes.
      </div>
    );
  }
  const data = history.map((h) => ({
    name: `#${h.cycle_number}`,
    days: h.duration_days,
    start: h.start_date,
    end: h.end_date,
  }));
  const avg = stats.avg_duration_days;
  const best = stats.best_duration_days;
  const worst = stats.worst_duration_days;
  return (
    <div className="h-44 rounded-xl border bg-white p-3 shadow-sm" data-testid="cycle-history-bar-strip">
      <div className="mb-2 flex items-center justify-between text-xs text-slate-500">
        <span className="uppercase tracking-wider">Cycle history</span>
        <span>avg <span className="font-mono text-foreground">{avg ?? "—"}</span> d · best <span className="font-mono text-emerald-700">{best ?? "—"}</span> · worst <span className="font-mono text-rose-700">{worst ?? "—"}</span></span>
      </div>
      <ResponsiveContainer width="100%" height="75%">
        <BarChart data={data} margin={{ top: 6, right: 8, left: -16, bottom: 0 }}>
          <XAxis dataKey="name" tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 11, fill: "#64748b" }} axisLine={false} tickLine={false} width={28} />
          <Tooltip cursor={{ fill: "rgba(245,158,11,0.06)" }} contentStyle={{ borderRadius: 8, fontSize: 12 }} formatter={(v) => [`${v} days`, "Duration"]} labelFormatter={(_, p) => p?.[0]?.payload ? `Cycle ${p[0].payload.name} · ${p[0].payload.start} → ${p[0].payload.end}` : ''} />
          {avg != null ? <ReferenceLine y={avg} stroke="#94a3b8" strokeDasharray="3 3" label={{ value: `avg ${avg}d`, position: "right", fontSize: 10, fill: "#64748b" }} /> : null}
          <Bar dataKey="days" radius={[6, 6, 0, 0]}>
            {data.map((d, i) => (
              <Cell key={i} fill={d.days === best ? "#10b981" : d.days === worst ? "#f43f5e" : "#f59e0b"} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
